import { NodoEstructuraJerarquica } from './nodo-estructura-jerarquica.model';
import { EstructuraJerarquica } from './estructura-jerarquica.model';
import { Usuario } from './usuario.model';
import {TablaDeEvaluacion} from './tabla-de-evaluacion.model';
import {MarcoDeReferencia} from './marco-de-referencia.model';

export class AnalisisDeBrechas
{
    id: number;
    nombre: string;
    estructuraJerarquica: EstructuraJerarquica;
    nodoEstructuraJerarquica: NodoEstructuraJerarquica;
    responsable: Usuario;
    estado: string;
    creador :Usuario;
    fechaCreado: Date;
    fechaFin: Date;
    tablaDeAnalisisDeBrechas: TablaDeEvaluacion;
    marcoDeReferencia: MarcoDeReferencia;

    /**
     * Constructor
     *
     * @param analisisDeBrechas
     */
    constructor(analisisDeBrechas)
    {
        {
            this.id = analisisDeBrechas.id || null;
            this.nombre = analisisDeBrechas.nombre || '';
            this.estado = analisisDeBrechas.estado || null;
            this.estructuraJerarquica = analisisDeBrechas.estructuraJerarquica || null;
            this.nodoEstructuraJerarquica= analisisDeBrechas.nodoEstructuraJerarquica || null;
            this.responsable = analisisDeBrechas.responsable || null;
            this.creador= analisisDeBrechas.creador || null;
            this.fechaCreado= analisisDeBrechas.fechaCreado || new Date();
            this.fechaFin = analisisDeBrechas.fechaFin || null;
            this.tablaDeAnalisisDeBrechas = analisisDeBrechas.tablaDeAnalisisDeBrechas || null;
            this.marcoDeReferencia = analisisDeBrechas.marcoDeReferencia || null;
        }
    }
}
